(() => {
  function initMegaMenus() {
    const replayMegaStagger = (detail) => {
      const animatedItems = detail.querySelectorAll(
        '.tcs-luxury-level-mega__title, .tcs-luxury-level-mega__column, .tcs-luxury-level-mega__feature, .tcs-luxury-level-mega__social, .tcs-luxury-level-mega__bottom-bar'
      );

      if (!animatedItems.length) return;

      animatedItems.forEach((item) => {
        item.style.animation = 'none';
      });

      detail.offsetHeight;

      window.requestAnimationFrame(() => {
        animatedItems.forEach((item) => {
          item.style.animation = '';
        });
      });
    };

    const openMegaMenu = (detail, detailsItems) => {
      detailsItems.forEach((item) => { if (item !== detail) item.open = false; });
      detail.open = true;
      replayMegaStagger(detail);
    };

    document.querySelectorAll('[data-tcs-luxury-level-nav]').forEach((nav) => {
      const detailsItems = Array.from(nav.querySelectorAll('details'));
      detailsItems.forEach((detail) => {
        const summary = detail.querySelector('summary');
        const mode = detail.dataset.openMode || (detail.classList.contains('tcs-mega--click') ? 'click' : 'hover');

        if (mode === 'hover') {
          detail.addEventListener('mouseenter', () => {
            openMegaMenu(detail, detailsItems);
          });
          detail.addEventListener('mouseleave', () => {
            window.setTimeout(() => {
              if (!detail.matches(':hover') && !detail.contains(document.activeElement)) detail.open = false;
            }, 120);
          });
          detail.addEventListener('focusin', () => {
            openMegaMenu(detail, detailsItems);
          });
          detail.addEventListener('focusout', (event) => {
            if (!detail.contains(event.relatedTarget)) detail.open = false;
          });
          if (summary) {
            summary.addEventListener('click', (event) => {
              if (window.matchMedia('(min-width: 990px)').matches) event.preventDefault();
            });
          }
        }

        if (mode === 'click' && summary) {
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            const nextState = !detail.open;
            detailsItems.forEach((item) => item.open = false);
            detail.open = nextState;
            if (nextState) replayMegaStagger(detail);
          });
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') detailsItems.forEach((item) => item.open = false);
      });
      document.addEventListener('click', (event) => {
        if (!nav.contains(event.target)) detailsItems.forEach((item) => item.open = false);
      });
    });
  }

  function initMobileDrawer() {
    const toggle = document.querySelector('.tcs-mobile-toggle');
    const closeButtons = document.querySelectorAll('[data-tcs-mobile-close]');
    if (!toggle) return;
    const open = () => { document.body.classList.add('tcs-mobile-menu-open'); toggle.setAttribute('aria-expanded', 'true'); };
    const close = () => { document.body.classList.remove('tcs-mobile-menu-open'); toggle.setAttribute('aria-expanded', 'false'); };
    toggle.addEventListener('click', open);
    closeButtons.forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  }


  function initTCSScrollAnimation() {
    const update = () => {
      const isScrolled = window.scrollY > 24;
      const headers = document.querySelectorAll('.tcs-header-wrap[data-tcs-sticky-mode]');

      if (isScrolled) {
        document.body.classList.add('tcs-header-scrolled');
      } else {
        document.body.classList.remove('tcs-header-scrolled');
      }

      headers.forEach((header) => {
        header.classList.toggle('tcs-header-wrap--scrolled', isScrolled);
      });
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('shopify:section:load', update);
  }
  function initTCSSearchPopup() { return; }


  function initTCSPremiumSearchOnly() {
    if (document.documentElement.dataset.tcsPremiumSearchReady === 'true') return;
    document.documentElement.dataset.tcsPremiumSearchReady = 'true';

    const getPanel = () => document.getElementById('TCSPremiumSearch');
    const getTriggers = () => document.querySelectorAll('[data-tcs-premium-search-open]');
    let searchAbortController = null;
    let searchDebounceTimer = null;

    const escapeHTML = (value) => {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    };

    const getSuggestEndpoint = (query) => {
      const root = window.Shopify?.routes?.root || '/';
      const cleanRoot = root.endsWith('/') ? root : `${root}/`;
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor',
      });

      return `${cleanRoot}search/suggest.json?${params.toString()}`;
    };

    const formatPrice = (price) => {
      if (!price) return '';
      if (typeof price === 'string') return price;
      const cents = Number(price);
      if (Number.isNaN(cents)) return '';

      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'AUD',
      }).format(cents / 100);
    };

    const renderSearchResults = (panel, query, results) => {
      const container = panel ? panel.querySelector('[data-tcs-premium-search-results]') : null;
      if (!container) return;

      const products = results?.resources?.results?.products || [];
      const collections = results?.resources?.results?.collections || [];
      const suggestions = results?.resources?.results?.queries || [];
      const items = products.slice(0, 6);

      if (!query) {
        container.classList.remove('is-visible');
        container.innerHTML = '';
        return;
      }

      if (!items.length && !collections.length && !suggestions.length) {
        container.innerHTML = `
          <p class="tcs-premium-search__results-heading">Search results</p>
          <p class="tcs-premium-search__results-empty">No quick results found. Press enter to search for "${escapeHTML(query)}".</p>
        `;
        container.classList.add('is-visible');
        return;
      }

      const productMarkup = items.map((product) => {
        const image = product.featured_image?.url || product.image || '';
        const price = formatPrice(product.price || product.price_min);
        const title = escapeHTML(product.title);
        const url = product.url || `/products/${product.handle || ''}`;

        return `
          <li class="tcs-premium-search__result-item">
            <a class="tcs-premium-search__result-link" href="${url}">
              ${image ? `<img class="tcs-premium-search__result-image" src="${image}" alt="${title}" loading="lazy">` : '<span class="tcs-premium-search__result-image" aria-hidden="true"></span>'}
              <span>
                <span class="tcs-premium-search__result-title">${title}</span>
                ${price ? `<span class="tcs-premium-search__result-price">${escapeHTML(price)}</span>` : ''}
              </span>
            </a>
          </li>
        `;
      }).join('');

      const collectionMarkup = collections.slice(0, 2).map((collection) => `
        <li class="tcs-premium-search__result-item">
          <a class="tcs-premium-search__result-link" href="${collection.url}">
            <span class="tcs-premium-search__result-image" aria-hidden="true"></span>
            <span>
              <span class="tcs-premium-search__result-title">${escapeHTML(collection.title)}</span>
              <span class="tcs-premium-search__result-price">Collection</span>
            </span>
          </a>
        </li>
      `).join('');

      container.innerHTML = `
        <p class="tcs-premium-search__results-heading">Search results</p>
        <ul class="tcs-premium-search__results-list">${productMarkup}${collectionMarkup}</ul>
        <a class="tcs-premium-search__view-all" href="/search?q=${encodeURIComponent(query)}">View all results for "${escapeHTML(query)}"</a>
      `;
      container.classList.add('is-visible');
    };

    const updateSearchResults = (panel) => {
      const input = panel ? panel.querySelector('.tcs-premium-search__input') : null;
      const query = input ? input.value.trim() : '';

      window.clearTimeout(searchDebounceTimer);
      if (searchAbortController) searchAbortController.abort();

      if (!query) {
        renderSearchResults(panel, '', null);
        return;
      }

      searchDebounceTimer = window.setTimeout(() => {
        searchAbortController = new AbortController();
        fetch(getSuggestEndpoint(query), { signal: searchAbortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.json();
          })
          .then((results) => renderSearchResults(panel, query, results))
          .catch((error) => {
            if (error.name === 'AbortError') return;
            renderSearchResults(panel, query, null);
          });
      }, 180);
    };

    const updateClear = (panel) => {
      const input = panel ? panel.querySelector('.tcs-premium-search__input') : null;
      const clear = panel ? panel.querySelector('.tcs-premium-search__clear') : null;
      if (!clear || !input) return;
      clear.classList.toggle('is-visible', input.value.length > 0);
    };

    const open = () => {
      const panel = getPanel();
      if (!panel) return;
      const input = panel.querySelector('.tcs-premium-search__input');

      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tcs-premium-search-open');
      getTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));

      window.setTimeout(() => {
        if (input) input.focus();
        updateClear(panel);
      }, 120);
    };

    const close = () => {
      const panel = getPanel();
      if (!panel) return;

      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tcs-premium-search-open');
      getTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-tcs-premium-search-open]');
      if (openButton) {
        event.preventDefault();
        document.body.classList.remove('tcs-mobile-menu-open');
        document.querySelector('.tcs-mobile-toggle')?.setAttribute('aria-expanded', 'false');
        open();
        return;
      }

      const closeButton = event.target.closest('[data-tcs-premium-search-close]');
      if (closeButton) {
        event.preventDefault();
        close();
        return;
      }

      const clear = event.target.closest('.tcs-premium-search__clear');
      const panel = getPanel();
      if (clear) {
        const input = panel ? panel.querySelector('.tcs-premium-search__input') : null;
        event.preventDefault();
        if (!input) return;
        input.value = '';
        updateClear(panel);
        renderSearchResults(panel, '', null);
        input.focus();
        return;
      }

      if (panel && panel.classList.contains('is-open') && !event.target.closest('.tcs-premium-search__panel')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('input', (event) => {
      if (event.target.matches('.tcs-premium-search__input')) {
        const panel = getPanel();
        updateClear(panel);
        updateSearchResults(panel);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMegaMenus();
    initMobileDrawer();
    initTCSPremiumSearchOnly();
    initTCSScrollAnimation();
    initTCSSearchPopup();
    if (typeof initTCSMobileSearch === 'function') initTCSMobileSearch();
    if (typeof initTCSDropdownSearch === 'function') initTCSDropdownSearch();
    if (typeof initTCSSearchClearButton === 'function') initTCSSearchClearButton();
  });
})();
